import React from 'react';
import { useLocation } from 'react-router-dom';
export default function StartupPageTitle({ icon: Icon, children, className = '', ...props }) {
  const { pathname } = useLocation();
  return <h1 {...props} className={`startup-page-title ${className}`}>
    <Icon size={24} weight="regular" aria-hidden="true" className="startup-page-title-icon" />
    <span className="startup-heading-text">{children}</span>
    <span key={pathname} className="startup-heading-underline" aria-hidden="true" />
  </h1>;
}
